// @ai-generated 2026-07-28T15:01:24+00:00 by niklas.eicker@tngtech.com using Claude Opus 5
import type { BadgeVariations } from '@synqo/frontend-component-library';
import { EnumRequisitionStatus } from './Generated';

/**
 * Customer-facing wording, deliberately separate from {@link getEnumRequisitionStatusLabel}: the
 * same state is "Übermittelt" to the customer and "Offen" to the operator.
 */
export function getPortalRequisitionStatusLabel(value: EnumRequisitionStatus): string {
    switch (value) {
        case EnumRequisitionStatus.Open:
            return 'Übermittelt';
        case EnumRequisitionStatus.UnderReview:
            return 'Wird geprüft';
        case EnumRequisitionStatus.InProgress:
            return 'In Bearbeitung';
        case EnumRequisitionStatus.Completed:
            return 'Abgeschlossen';
        case EnumRequisitionStatus.Rejected:
            return 'Abgelehnt';
        default:
            return 'Nicht definiert';
    }
}

export function getPortalRequisitionStatusVariant(value: EnumRequisitionStatus): BadgeVariations {
    switch (value) {
        case EnumRequisitionStatus.Open:
            return 'default';
        case EnumRequisitionStatus.UnderReview:
            return 'warning';
        case EnumRequisitionStatus.InProgress:
            return 'info';
        // 'primary' is the design's teal; the library's 'success' variant is lime.
        case EnumRequisitionStatus.Completed:
            return 'primary';
        case EnumRequisitionStatus.Rejected:
            return 'danger';
        default:
            return 'default';
    }
}
